import { render, staticRenderFns } from "./BeaconList.vue?vue&type=template&id=72320642&"
import script from "./BeaconList.vue?vue&type=script&lang=ts&"
export * from "./BeaconList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72320642')) {
      api.createRecord('72320642', component.options)
    } else {
      api.reload('72320642', component.options)
    }
    module.hot.accept("./BeaconList.vue?vue&type=template&id=72320642&", function () {
      api.rerender('72320642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/BeaconList.vue"
export default component.exports